import {
  GridOptions,
  ICellRendererParams,
  ICellEditorParams,
  ITooltipParams,
  ValueGetterParams,
  ValueFormatterParams,
} from 'ag-grid-enterprise';
import {
  CellClickedEvent,
  CellDoubleClickedEvent,
  CellEditorSelectorResult,
  CellRendererSelectorResult,
  ColumnPinnedType,
  EditableCallbackParams,
  ValueGetterFunc,
} from 'ag-grid-community';

import { Dictionary } from '../cross-cutting/models';

export interface TsTableOptions {
  headerName?: string;
  headerClass?: string;
  headerTooltip?: string;
  headerCheckboxSelection?: boolean;
  suppressHeaderMenuButton?: boolean;
  suppressHeaderContextMenu?: boolean;
  headerComponent?: any;
  headerComponentParams?: any;
  field?: string;
  cellRendererParams?: any;
  sortable?: boolean;
  filter?: boolean;
  resizable?: boolean;
  checkboxSelection?: boolean;
  suppressMovable?: boolean;
  lockPosition?: 'left' | 'right';
  lockPinned?: boolean;
  editable?: boolean | ((params: EditableCallbackParams) => boolean);
  isNestedField?: boolean;
  cellEditorPopup?: boolean;
  cellRenderer?: any | ((params: ICellRendererParams) => any);
  pinned?: ColumnPinnedType;
  flex?: number;
  rowGroup?: boolean;
  rowDrag?: boolean;
  aggFunc?: any;
  enableValue?: boolean;
  hide?: boolean;
  width?: number;
  cellStyle?: any;
  autoHeight?: boolean;
  cellEditor?: any;
  cellEditorParams?: any;
  cellEditorSelectorParams?: any;
  maxWidth?: number;
  minWidth?: number;
  suppressAutoSize?: boolean;
  suppressSizeToFit?: boolean;
  cellClass?: string | string[] | ((params: any) => string | string[]);
  cellClassRules?: any;
  titleCase?: boolean;
  tooltipField?: string;
  wrapText?: boolean;
  contextMenuItems?: any[];
  sort?: 'asc' | 'desc' | null;
  colId?: string;
  valueFormatter?: (params: ValueFormatterParams) => string;
  valueGetter?: (params: ValueGetterParams) => string | ValueGetterFunc<any, any>;
  onCellClicked?: (event: CellClickedEvent) => void;
  onCellDoubleClicked?: (event: CellDoubleClickedEvent) => void;
  /** When true, keyboard focus (Tab/Enter/F2) invokes onDialogEdit instead of inline editing. */
  editViaDialog?: boolean;
  onDialogEdit?: (rowData: any) => void;
  cellEditorSelector?: (params: ICellEditorParams) => CellEditorSelectorResult | undefined;
  cellRendererSelector?: (params: ICellRendererParams) => CellRendererSelectorResult | undefined;
  tooltipValueGetter?: (params: ITooltipParams) => string | any;
  tooltipComponent?: any;
  parentFieldMeta?: FieldDefMeta;
}

export interface ColumnDef {
  tsTableOptions?: TsTableOptions;
  label: string;
  name: string;
  groupLabel?: string;
  type?: FieldDefType | ((params: any) => FieldDefType);
  meta?: FieldDefMeta;
  _parentFieldName?: string;
  _parentFieldLabel?: string;
  related_to_type?: string;
  locked?: boolean;
  _parentFieldMeta?: FieldDefMeta;
}

export type FieldDefType =
  | 'number'
  | 'money'
  | 'text'
  | 'percent'
  | 'select'
  | 'checkbox'
  | 'date'
  | 'datetime'
  | 'decimal'
  | 'textarea'
  | 'record'
  | 'url'
  | 'typeahead'
  | 'tags'
  | 'year'
  | 'id';

export type FieldDefMeta = {
  option_name?: string;
  filtering?: {
    exclude_in_nested_filter?: boolean;
    operators?: string[];
    functions?: string[];
    values?: string[];
  };
  multi_select?: boolean;
  options?: any[];
  readonly?: boolean;
  record_type?: string;
  scale?: any;
  thousands_separator?: boolean;
  sorting?: string;
  group?: any;
  groupable?: boolean;
  value_hidden?: boolean;
};

export type OptionsFilterFn = Dictionary<(options: any[], model: any) => any[]>;

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  autoSizeStrategy: {
    type: 'fitCellContents',
  },
};
